import {
  CloseSharp,
  Delete,
  PreviewSharp,
  SaveSharp,
} from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  Grid,
  IconButton,
  Stack,
  TextField
} from "@mui/material";
import { useContext, useEffect, useState } from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
//import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import { ShoppingCartContext } from "../Context/ShoppingCartContext";
import InvoicePreview from "../Reports/InvoicePreview";


import { useTheme } from "@mui/material/styles";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "../../axiosInstances";
const phoneRegExp = /^(^\+251|^251|^0)?(9|7)\d{8}$/;
const validationSchema = Yup.object().shape({
  Name: Yup.string().required("Name is required!!!"),
  Category: Yup.string().required("Busines Type is required!!!"),
  Username: Yup.string().required("Username is required!!!"),
  Password: Yup.string().required("Password is required!!!"),
  Email: Yup.string()
    .trim() // Removes accidental leading/trailing spaces
    .lowercase() // Normalizes the email to lowercase
    .email('Invalid email format') // Basic format check (e.g., must have @ and .)
    .required('Email is required'),
  Mobile: Yup.string()
    .matches(phoneRegExp, 'Invalid Ethiopian mobile number (use 09... or 07...)')
    .required('Mobile number is required')
    .test('len', 'Mobile number must be 10 digits', val => {
      // Logic to check length after removing +251 or 251
      const cleanValue = val?.replace('+251', '0').replace(/^251/, '0');
      return cleanValue?.length === 10;
    }),
  TinNumber: Yup.string()
    .min(10, "Minumber length is 10")
    .max(10, "Maximum length is 10")
    .required("Tin Number is required!!!"),
});
export default function SignupModel(props) {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const { globalUser, globalToken } =
    useContext(ShoppingCartContext);
  const [open, setOpen] = useState(false);
  const [isAddresssDisplayed, setIsAddresssDisplayed] = useState(false);
  const [isLicenseDisplayed, setIsLicenseDisplayed] = useState(false);
  var fileObj = [];
  var fileArray = [];

  const [id, setId] = useState(0);
  const [tinNumber, setTinNumber] = useState('');
  const [type, setType] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const [logoFiles, setLogoFiles] = useState(splitPictures(''));
  const [paperHeader, setPaperHeader] = useState(splitPictures(''));
  const [amount, setAmount] = useState(0);
  const [commision, setCommission] = useState(0);
  const [remark, setRemark] = useState('');
  const [route, setRoute] = useState(0);
  const [routeObject, setRouteObject] = useState('');
  const [region, setRegion] = useState('');
  const [zone, setZone] = useState('');
  const [wereda, setWereda] = useState('');
  const [houseNo, setHouseNo] = useState('');
  const [surrounding, setSurrounding] = useState('');
  const [telephone, setTelephone] = useState('');
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');
  const [web, setWeb] = useState('');
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [lat, setLat] = useState('');
  const [longt, setLongt] = useState('');
  const [businessCategories, setBusinessCategories] = useState([]);
  // const [startDate, setStartDate] = useState(props?.data??.LicenseStartDate?props?.data?.LicenseStartDate:format(new Date(), "yyyy-MM-dd") );
  // const [endDate, setEndDate] = useState(props?.data??.LicenseEndDate?props?.data?.LicenseEndDate:format(new Date(), "yyyy-MM-dd") );
  const [salesRoutesList, setSalesRoutesList] = useState([]);
  function splitPictures(picType) {
    try {
      fileArray = [];
      ((picType === "Logo") ? props?.data?.Logo : props?.data?.PaperHeader)?.split(",").map(function (address, index) {
        if (!fileArray.includes(address) && address.length > 0) {
          fileArray.push("https://ethiob2b.com" + address);
          //document.getElementById('file').files.push(new Blob(address))
        }
      });
      return fileArray;
    } catch (err) {
      console.log(err);
    }
  }


  function uploadLogo(e) {
    setLogoFiles([]);
    fileObj = [];
    fileArray = [];
    fileObj.push(e.target.files);
    /* for (let i = 0; i < fileObj[0].length; i++) {
      fileArray.push();
    } */
    setLogoFiles([fileObj.length > 0 && URL.createObjectURL(fileObj[0][0])]);
  }
  function uploadPaperHeader(e) {
    setPaperHeader([]);
    fileObj = [];
    fileArray = [];
    fileObj.push(e.target.files);
    /* for (let i = 0; i < fileObj[0].length; i++) {
      fileArray.push();
    } */
    setPaperHeader([fileObj.length > 0 && URL.createObjectURL(fileObj[0][0])]);
  }
  const handleSubmit = async (values) => {
    if (await isUserNameOccupied(values)) {
      alert("Please change the username. It is already occupied");
      return;
    }
    if (window.confirm("Are you sure you want to save?")) {

      try {
        var fd = new FormData();
        fd.append("Id", 0);
        fd.append("TinNumber", values.TinNumber);
        fd.append("Type", type);
        fd.append("Name", values.Name);
        fd.append("Description", description);
        fd.append("Category", values.Category);
        if (Array.from(document.getElementById("Logo").files).length > 0) {
          Array.from(document.getElementById("Logo").files).map((file) => {
            fd.append("Logo", file);
          });
        } else {
          fd.append("OriginalLogo", logoFiles[0]?.replace("https://ethiob2b.com", ""));
        }
        if (Array.from(document.getElementById("PaperHeader").files).length > 0) {
          Array.from(document.getElementById("PaperHeader").files).map((file) => {
            fd.append("PaperHeader", file);
          });
        } else {
          fd.append("OriginalPaperHeader", paperHeader[0]?.replace("https://ethiob2b.com", ""));
        }

        fd.append("Amount", amount);
        fd.append("Commision", commision);
        fd.append("Remark", remark);
        fd.append("Route", route);
        fd.append("Region", region);
        fd.append("Zone", zone);
        fd.append("Wereda", wereda);
        fd.append("HouseNo", houseNo);
        fd.append("Surrounding", surrounding);
        fd.append("Telephone", telephone);

        fd.append("Mobile", values.Mobile);
        fd.append("Email", values.Email);

        fd.append("Web", web);

        fd.append("UserName", values.Username);
        fd.append("Password", values.Password);

        fd.append("Lat", lat);
        fd.append("Longt", longt);

        fd.append("Parent", 0);
        fd.append("BirthDate", "");
        fd.append("Gender", "");
        fd.append("Race", "");
        fd.append("Status", "Testing");
        alert('end of endkkkkkk')

        axios.post("/suppliers", fd, {
          headers: {
            "Content-Type": "multipart/form-data",

          },
        }).then(() => {

          /* var fdli = new FormData();
          fdli.append("Company", id);
          fdli.append("LicenseStartDate", format(new Date(), "yyyy-MM-dd"));
          fdli.append("LicenseEndDate", format(new Date() + 30, "yyyy-MM-dd"));
          axios.post("/licenseinformation", fdli, {
            headers: {
              "Content-Type": "application/json",
            },
          }); */
        });
      } catch (err) {
        console.log('error', err)
      } finally {
        try {
          props.setParentUpdate(!props.ParentUpdate);
        } catch (err) { }

        setOpen(false);
      }
    }
  };
  const handleDelete = async () => {
    try {
      await axios
        .get("/vouchers/getByParentAndCustomerOrSupplier?Supplier=" + id, {
          headers: {
            token: globalToken,
          },
        })
        .then((response) => {
          if (response.data.data.length <= 0) {
            deleteNoTransaction();
          } else {
            alert(
              "Can not delete this " + type + ".It has transaction history"
            );
            setOpen(false);
            return;
          }
        });
    } catch (err) { }
  };
  const deleteNoTransaction = () => {
    if (window.confirm("Are you sure you want to delete?")) {
      try {
        axios.delete("/suppliers/delete?Id=" + id, {
          headers: {
            token: globalToken,
          },
        });
      } catch (err) {
      } finally {
        props.setParentUpdate(!props.ParentUpdate);
        setOpen(false);
      }
    }
  };
  const isUserNameOccupied = async (values) => {

    try {
      var formdata = new FormData();
      formdata.append("Username", values.Username);

      const response = await axios.post("/employees/CheckUserName", formdata, {
        headers: { "Content-Type": "application/json" }
      })

      if (response.data.data && response.data.data.length > 0) {

        return true
      } else {
        return false
      }

    } catch (ex) {

    }
    //errRef.current.focus();
  };
  const loadBusinessTypesList = () => {
    axios
      .get(
        "/itemcategories/getByType?Parent=0", {
        headers: {
          "Content-Type": "application/json",
        }
      })
      .then((response) => {
        if (response.data.data) {
          setBusinessCategories(response.data.data.map(item => item.Name));
        } else {
          alert("log out and log in again");
        }
      });
  };
  useEffect(() => {
    loadBusinessTypesList();
  }, [])

  return (
    <div width="500">
      <label onClick={() => setOpen(true)}>{props.icon}</label>
      <Formik
        initialValues={{}}
        onSubmit={
          handleSubmit
        }
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({ values, errors, handleChange, handleBlur, handleSubmit }) => (
          <Dialog
            maxWidth="md"
            /*      PaperProps={{
               sx: {
                 height: '80vh',   // 80% of viewport height
                 maxHeight: '90vh',
               },
             }} */
            PaperProps={{
              style: {
                borderRadius: 24,
                backgroundColor: '#fffcf9', // Warm off-white
                boxShadow: '0 8px 30px rgba(0,0,0,0.08)'
              }
            }}
            open={open}
            onClose={() => {
              setOpen(false);
            }}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle
              bgcolor={theme.palette.primary.main}
              color={theme.palette.primary.contrastText}
            >
              <Stack direction='row' style={{ flex: 1 }}>
                <div style={{ flex: 1 }}>
                  <label>New Company Registration Form </label>



                </div>
                <div style={{ marginLeft: 20, marginTop: -3, marginRight: -5 }}>
                  <IconButton style={{ background: theme.palette.primary.light, alignItems: 'center', justifyItems: 'center' }} onClick={() => setOpen(false)} size="small"><CloseSharp /></IconButton>
                </div>

              </Stack>
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {/* <h5 style={{ fontWeight: "bold" }}>{props.Title}</h5> */}
                <hr></hr>

                <Grid container>
                  <Grid item xs={12} md={6}>
                    <TextField
                      size="small"
                      variant="standard"
                      label={t("Company Name")}
                      value={values.Name}
                      onChange={handleChange("Name")}
                      onBlur={handleBlur("Name")}
                      sx={{ width: "95%" }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors.Name && (
                      <span style={{ color: "red" }}> {errors.Name}</span>
                    )}
                  </Grid>

                  <Grid item xs={12} md={6}>
                    Type: {type}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      variant="standard"
                      size="small"
                      label={t("Tin Number")}
                      value={values.TinNumber}
                      onChange={handleChange("TinNumber")}
                      onBlur={handleBlur("TinNumber")}
                      sx={{ width: "95%" }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors.TinNumber && (
                      <span style={{ color: "red" }}> {errors.TinNumber}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      size="small"
                      variant="standard"
                      label={t("description")}
                      defaultValue={description}
                      multiline
                      onChange={(e) => {
                        setDescription(e.target.value);
                      }}
                      sx={{ width: "95%" }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      size="small"
                      variant="standard"
                      required
                      label="Username"
                      name="Username"
                      sx={{ width: "95%", marginBottom: 2 }}
                      value={values.Username}
                      onChange={
                        handleChange("Username")
                      }
                      onBlur={handleBlur("Username")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors.Username && (
                      <span style={{ color: "red" }}> {errors.Username}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      size="small"
                      type="password"
                      required
                      variant="standard"
                      label="Password"
                      name="Password"
                      sx={{ width: "95%", marginBottom: 2 }}
                      value={values.Password}
                      onChange={
                        //(e) => {
                        handleChange("Password") // setName(e.target.value);
                      }
                      onBlur={handleBlur("Password")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors.Password && (
                      <span style={{ color: "red" }}> {errors.Password}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>

                    <Autocomplete
                      //disabled={((status === "Received") || (globalUser.Name===transferedTo)) ? true : false}
                      disablePortal
                      selectOnFocus
                      autoHighlight
                      name="Category"
                      getOptionLabel={(option) => option}
                      value={
                        values.Category
                      }
                      id="Store"
                      onChange={(e) => {
                        values.Category = e.target.textContent;
                        setCategory(e.target.textContent)
                      }
                      }
                      onBlur={handleBlur("Category")}
                      options={
                        (!(businessCategories === undefined) &&
                          !(businessCategories === null) && businessCategories.length > 0) ?
                          businessCategories : ['']
                      }
                      sx={{
                        width: "95%",
                        marginBottom: 2,
                        borderRadius: "25%",
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Bussiness Type"
                          variant="standard"
                        //error={!fromAirport ? true : false}
                        />
                      )}
                    />
                    {errors.Category && (
                      <span style={{ color: "red" }}> {errors.Category}</span>
                    )}

                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      size="small"
                      variant="standard"
                      label="Mobile"
                      name="Mobile"
                      defaultValue={mobile}
                      sx={{ width: "95%" }}
                      onChange={(e) => {
                        setMobile(e.target.value);
                        values.Mobile = e.target.value;
                      }}
                      onBlur={handleBlur("Mobile")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors.Mobile && (
                      <span style={{ color: "red" }}> {errors.Mobile}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      size="small"
                      variant="standard"
                      label="Email"
                      name="Email"
                      defaultValue={email}
                      sx={{ width: "95%" }}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        values.Email = e.target.value;
                      }}
                      onBlur={handleBlur("Email")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors.Email && (
                      <span style={{ color: "red" }}> {errors.Email}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} sx={{ marginBottom: 1 }}>
                    <Stack
                      style={{
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setIsAddresssDisplayed(!isAddresssDisplayed)
                      }
                    >
                      License Period
                    </Stack>
                    <div
                      style={{
                        display: isAddresssDisplayed ? "block" : "none",
                      }}
                    >
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          mt={1}

                        >

                          <TextField
                            size="small"
                            label="Start Date"
                            type="date"
                            value={values.LicenseStartDate}
                            onChange={handleChange("LicenseStartDate")}
                            onBlur={handleBlur("LicenseStartDate")}

                            sx={{ width: "70%", marginBottom: 1 }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          mt={1}

                        >
                          <TextField
                            size="small"
                            label="End Date"
                            type="date"
                            value={values.LicenseEndDate}
                            onChange={handleChange("LicenseEndDate")}
                            onBlur={handleBlur("LicenseEndDate")}
                            sx={{ width: "70%", marginBottom: 1 }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Stack
                      style={{
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setIsLicenseDisplayed(!isLicenseDisplayed)
                      }
                    >
                      Customer Address and Logo
                    </Stack>
                    <div
                      style={{
                        display: isLicenseDisplayed ? "block" : "none",
                      }}
                    >
                      <Grid container>
                        <Grid item xs={12} md={6}>
                          <Autocomplete
                            disablePortal
                            selectOnFocus
                            id="route"
                            autoHighlight
                            defaultValue={
                              routeObject &&
                                !(routeObject === null) &&
                                routeObject.length > 0
                                ? routeObject[0]
                                : ""
                            }
                            getOptionLabel={(option) => option.Name}
                            onChange={(e, newValue) => {
                              setRouteObject([]);
                              setRouteObject((preValue) => [
                                ...preValue,
                                newValue,
                              ]);
                              setRoute(newValue.Id);
                            }}
                            options={salesRoutesList ? salesRoutesList : ['']}
                            sx={{
                              width: "95%",
                              borderRadius: "25%",
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={t("Route Name")}
                                variant="standard"
                              //error={!fromAirport ? true : false}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            size="small"
                            variant="standard"
                            label="Region"
                            defaultValue={region}
                            sx={{ width: "95%" }}
                            onChange={(e) => {
                              setRegion(e.target.value);
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            size="small"
                            variant="standard"
                            label="Zone"
                            defaultValue={zone}
                            sx={{ width: "95%" }}
                            onChange={(e) => {
                              setZone(e.target.value);
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            size="small"
                            variant="standard"
                            label="Wereda"
                            defaultValue={wereda}
                            sx={{ width: "95%" }}
                            onChange={(e) => {
                              setWereda(e.target.value);
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            size="small"
                            variant="standard"
                            label="HouseNo"
                            defaultValue={houseNo}
                            sx={{ width: "95%" }}
                            onChange={(e) => {
                              setHouseNo(e.target.value);
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            size="small"
                            variant="standard"
                            label="Surrounding"
                            defaultValue={surrounding}
                            sx={{ width: "95%" }}
                            onChange={(e) => {
                              setSurrounding(e.target.value);
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            size="small"
                            variant="standard"
                            label="telephone"
                            defaultValue={telephone}
                            sx={{ width: "95%" }}
                            onChange={(e) => {
                              setTelephone(e.target.value);
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>


                        <Grid item xs={12} md={6}>
                          <TextField
                            size="small"
                            variant="standard"
                            label="Web"
                            defaultValue={web}
                            sx={{ width: "95%" }}
                            onChange={(e) => {
                              setWeb(e.target.value);
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            size="small"
                            variant="standard"
                            label="Lat"
                            defaultValue={lat}
                            sx={{ width: "95%" }}
                            onChange={(e) => {
                              setLat(e.target.value);
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            size="small"
                            variant="standard"
                            label="Longt"
                            defaultValue={longt}
                            sx={{ width: "95%" }}
                            onChange={(e) => {
                              setLongt(e.target.value);
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          style={{

                            color: theme.palette.primary.contrastText,
                            cursor: "pointer",
                          }}
                        >
                          <label htmlFor="Logo" style={{ backgroundColor: theme.palette.primary.main, marginBottom: 2 }}>
                            Company Logo or Perosnal Picture{" "}
                            {logoFiles && (
                              <Button
                                endIcon={
                                  <CloseSharp style={{ color: "red" }} />
                                }
                                onClick={() => {
                                  setLogoFiles("");
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Logo"
                              onChange={uploadLogo}
                              hidden
                            />

                            <div className="form-group multi-preview">
                              {(logoFiles || []).map((address, index) => (

                                <img
                                  key={index}
                                  src={address}
                                  alt="..."
                                  style={{ width: "95%", height: "95" }}
                                />
                              ))}
                            </div>
                          </label>
                          <label htmlFor="PaperHeader" style={{ backgroundColor: theme.palette.primary.main }}>
                            Company Paper Header
                            {paperHeader && (
                              <Button
                                endIcon={
                                  <CloseSharp style={{ color: "red" }} />
                                }
                                onClick={() => {
                                  setPaperHeader("");
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="PaperHeader"
                              onChange={uploadPaperHeader}
                              hidden
                            />

                            <div className="form-group multi-preview">
                              {(paperHeader || []).map((address, index) => (

                                <img
                                  key={index}
                                  src={address}
                                  alt="..."
                                  style={{ width: "95%", height: "95" }}
                                />
                              ))}
                            </div>
                          </label>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </Grid>

                <hr></hr>
              </DialogContentText>
            </DialogContent>
            <DialogActions
              style={{
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                flexWrap: 'wrap',
              }}
            >
              {/*   <Button
            color="inherit"
            className="collapse-button"
            onClick={() => {
              setIsRouteCollapsed(!isRouteCollapsed);
            }}
          >
            Route
          </Button>| */}
              {props?.data && props?.data?.Name.length > 0 &&
                <>
                  <Button variant="standard"
                    sx={{
                      borderRadius: 5,
                      fontSize: "10px",
                      backgroundColor: theme.palette.primary.main,
                      '&:hover': { backgroundColor: theme.palette.primary.light }
                    }}
                    autoFocus endIcon={<PreviewSharp />}>
                    <InvoicePreview
                      icon={<div>Preview</div>}
                      Suppliers={[props?.data]}
                      Type="Supplier"
                      DocumentType={type + " Information"}
                    />
                  </Button>
                  |
                </>
              }
              <Button
                variant="standard"
                sx={{
                  borderRadius: 5,
                  fontSize: "10px",
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.light }
                }}
                autoFocus
                onClick={(e) => {
                  handleSubmit(values);
                }}
                endIcon={<SaveSharp />}
              >
                Save
              </Button>
              |
              {props?.data && props?.data?.Name.length > 0 &&
                <>
                  <Button
                    variant="standard"
                    sx={{
                      borderRadius: 5,
                      fontSize: "10px",
                      backgroundColor: theme.palette.primary.main,
                      '&:hover': { backgroundColor: theme.palette.primary.light }
                    }}
                    autoFocus
                    onClick={() => handleDelete()}
                    endIcon={<Delete />}
                  >
                    Delete
                  </Button>
                  |
                </>
              }
              <Button
                variant="standard"
                sx={{
                  borderRadius: 5,
                  fontSize: "10px",
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.light }
                }}
                onClick={() => setOpen(false)}
                autoFocus
                endIcon={<CloseSharp />}
              >
                Close
              </Button>
            </DialogActions>
            {/*   {routeObject && !(routeObject === null) && routeObject.length > 0 ? (
          <DialogActions
            className={`collapse-content ${
              !isRouteCollapsed ? "expanded" : "collapsed"
            }`}
            aria-expanded={isRouteCollapsed}
          >
            <Grid container  m={2}>
              <Grid item xs={3}>
                Route Name:
              </Grid>
              <Grid item xs={3}>
                {routeObject[0].Name}
              </Grid>

              <Grid item xs={3}>
                Delivery Person:
              </Grid>
              <Grid item xs={3}>
                {routeObject[0].DeliveryPersonName}
              </Grid>
              <Grid item xs={3}>
                Sales Representative:
              </Grid>
              <Grid item xs={3}>
                {routeObject[0].SalesRepresentativeName}
              </Grid>
              <Grid item xs={3}>
                Supervisor:
              </Grid>
              <Grid item xs={3}>
                {routeObject[0].SupervisorName}
              </Grid>
              <Grid item xs={3}>
                Path Information:
              </Grid>
              <Grid item xs={3}>
                {routeObject[0].PathDetail}
              </Grid>
              <Grid item xs={3}>
                Remark:
              </Grid>
              <Grid item xs={3}>
                {routeObject[0].Remark}
              </Grid>
            </Grid>
          </DialogActions>
        ) : (
          ""
        )} */}
          </Dialog>
        )}
      </Formik>
    </div>
  );
}
